'use client';

import { createContext, useContext } from 'react';
import type { FileWithPath } from '../../types/folder-tree-node';
import type { InsightsBulkImportQueueItem } from '../types/insights-bulk-import-queue-item';
export interface InsightsBulkImportContextValue {
  queue: InsightsBulkImportQueueItem[];
  startFileImport: (files: File[], targetFolderId: string | null) => Promise<void>;
  startFolderImport: (files: File[] | FileWithPath[], targetFolderId: string | null) => Promise<void>;
  retryItem: (clientId: string) => void;
  hasActiveWork: boolean;
  /**
   * Uploads sending bytes from this tab right now, including
   * ones whose rows were cleared from the list.
   */
  activeUploadCount: number;
  /** Abandon queued uploads and empty the client queue. */
  clearAll: () => void;
  /** Skip uploads for these client ids (after clear or per-item cancel). */
  isClientImportCancelled: (clientId: string) => boolean;
}
export const InsightsBulkImportContext = createContext<InsightsBulkImportContextValue | null>(null);
export function useInsightsBulkImport(): InsightsBulkImportContextValue {
  const ctx = useContext(InsightsBulkImportContext);
  if (!ctx) {
    throw new Error('useInsightsBulkImport must be used within InsightsBulkImportProvider');
  }
  return ctx;
}